import styled from 'styled-components';
import UnstyledBase from '../../layouts/Base';

// Base layout for application
export const Base = styled(UnstyledBase)`
  ${({ theme }) =>
    theme.brand.background.includes('https')
      ? `background: url(${theme.brand.background});
       background-size: cover;
    `
      : `background: ${theme.brand.background};`}
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    margin-bottom: 15px;
  }

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;

    & > *:not(:last-child) {
      margin-bottom: 0;
      margin-right: 15px;
    }
  `}
`;

export const FormGroup = styled.fieldset`
  & > *:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const PasswordRequirements = styled.ul`
  li {
    list-style-type: disc;
    margin-left: 15px;
  }
`;

// invalid-feedback
export const FieldError = styled.div`
  color: red;
  font-size: 12px;
  animation: fadeInn 0.3s ease-in forwards;

  div {
    margin-top: 5px;
    margin-left: 10px;
  }

  p {
    display: flex;
    align-items: center;
    gap: 10px;

    span {
      width: 8px;
      height: 8px;
      border-radius: 1px;
      position: relative;
      display: inline-block;
      background-color: red;
      flex: none;
    }

    &.valid {
      color: green;

      span {
        background-color: green;
        border-radius: 50%;
      }
    }
  }

  @keyframes fadeInn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

// passwordfieldwrapper
export const PasswordFieldWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  input {
    flex: 1;
    padding-right: 30px;
  }

  button {
    position: absolute;
    right: 10px;
    top: 50%;
    bottom: 0;
    margin: auto;
    background: none;
    border: none;
    cursor: pointer;
    transform: translateY(-50%);

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;
